import MDButton from "components/MDButton";
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useMaterialUIController } from "context";
import { useDispatch, useSelector } from "react-redux";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import SkLoading from "components/SkLoading";
import MDInput from "components/MDInput";
import AstrieskIcon from "components/AstrieskIcon";
import { Card, FormControl } from "@mui/material";
import { handleAlert } from "redux/festures/alertSlice";
import axios from "axios";
import { updateFAQ, createFAQ, getAllFAQ } from "redux/festures/faqSlice";

const Form = ({ isOpenUpdate, setIsOpenUpdate, setIsOpen, setIsOpenView, isOpenView }) => {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

  const [faqData, setFaqData] = useState({
    question: "",
    answer: "",
    helpSupportId: "",
  });

  const [helpSupportList, setHelpSupportList] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const admin = localStorage.getItem("admin_id");
  const dispatch = useDispatch();
  const { isLoading, singleFAQ } = useSelector((state) => state.isFAQ);

  // 🔹 Fetch Help Support List
  useEffect(() => {
    const fetchHelpSupport = async () => {
      try {
        const token = localStorage.getItem("token");
        const res = await axios.get(`${process.env.REACT_APP_APII}/help-support`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (res.data?.success) {
          setHelpSupportList(res.data.data);
        }
      } catch (error) {
        
      }
    };

    fetchHelpSupport();
  }, []);

  // 🔹 Set data in Update mode
  useEffect(() => {
    if (isOpenUpdate && isOpenView) {
      setFaqData({
        question: isOpenView?.question || "",
        answer: isOpenView?.answer || "",
        helpSupportId: isOpenView?.helpSupportId || "", // ← safe
      });
    } else {
      // 🔥 IMPORTANT — har new create pe blank
      setFaqData({
        question: "",
        answer: "",
        helpSupportId: "",
      });
    }
  }, [isOpenView, isOpenUpdate]);

  const handleForm = (e) => {
    const { name, value } = e.target;

    // Agar dropdown hai → direct set karo
    if (name === "helpSupportId") {
      setFaqData((prev) => ({
        ...prev,
        [name]: value,
      }));
      return;
    }

    // Sirf letters + space (sirf question/answer ke liye)
    const onlyLetters = value.replace(/[^A-Za-z\s]/g, "");

    setFaqData((prev) => ({
      ...prev,
      [name]: onlyLetters,
    }));
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();

    if (isSubmitting) return; // 🚫 second click block

    setIsSubmitting(true); // 🔒 lock button

    dispatch(
      isOpenUpdate
        ? updateFAQ({
            FAQId: isOpenView?._id,
            adminId: admin,
            data: faqData,
          })
        : createFAQ({
            url: `${process.env.REACT_APP_APII}/createFAQ/${admin}`,
            data: faqData,
          })
    )
      .unwrap?.() // <-- important
      .then((res) => {
        setIsSubmitting(false); // ✅ unlock button

        dispatch(
          handleAlert({
            isOpen: true,
            type: res?.success ? "success" : "error",
            msg: res?.message,
          })
        );

        if (res?.success) {
          setIsOpen(false);
          setIsOpenUpdate(false);
          setIsOpenView(null);
          setFaqData({ question: "", answer: "", helpSupportId: "" });
          dispatch(getAllFAQ(`${process.env.REACT_APP_APII}/getAllFAQ`));
        }
      })
      .catch(() => setIsSubmitting(false)); // 🔄 unlock on error
  };

  return isLoading ? (
    <SkLoading />
  ) : (
    <MDBox display="flex" flexDirection="column" alignItems="center" gap={4} width="100%">
      <Card sx={{ width: "100%", textAlign: "center", py: 1 }}>
        <MDTypography variant="h6">{isOpenUpdate ? "Update FAQ" : "Create FAQ"}</MDTypography>
      </Card>

      <MDBox
        component="form"
        onSubmit={handleFormSubmit}
        sx={({ palette: { dark, white } }) => ({
          width: "100%",
          border: "1px solid",
          borderColor: darkMode ? white.main : dark.main,
          borderRadius: 3,
          p: 3,
          display: "flex",
          flexDirection: "column",
          gap: 3,
          alignItems: "center",
        })}
      >
        {/* 🔹 Help Support Dropdown */}
        <MDBox width="90%">
          <MDTypography variant="h6">
            Help Support Category <AstrieskIcon />
          </MDTypography>
          <FormControl fullWidth>
            <select
              name="helpSupportId"
              value={faqData.helpSupportId}
              onChange={handleForm}
              required
              style={{
                padding: "12px",
                borderRadius: "8px",
                border: "1px solid #ccc",
                width: "100%",
              }}
            >
              <option value="">Select Help Support</option>
              {helpSupportList.map((item) => (
                <option key={item._id} value={item._id}>
                  {item.heading}
                </option>
              ))}
            </select>
          </FormControl>
        </MDBox>

        {/* 🔹 Question */}
        <MDBox width="90%">
          <MDTypography variant="h6">
            FAQ Question <AstrieskIcon />
          </MDTypography>
          <MDInput
            required
            fullWidth
            name="question"
            value={faqData.question}
            onChange={handleForm}
          />
        </MDBox>

        {/* 🔹 Answer */}
        <MDBox width="90%">
          <MDTypography variant="h6">
            FAQ Answer <AstrieskIcon />
          </MDTypography>
          <MDInput required fullWidth name="answer" value={faqData.answer} onChange={handleForm} />
        </MDBox>

        {/* 🔹 Submit */}
        <MDBox width="100%" display="flex" justifyContent="flex-end">
          <MDButton type="submit" color="info" variant="gradient" disabled={isSubmitting}>
            {isSubmitting
              ? isOpenUpdate
                ? "Updating..."
                : "Creating..."
              : isOpenUpdate
                ? "Update FAQ"
                : "Create FAQ"}
          </MDButton>
        </MDBox>
      </MDBox>
    </MDBox>
  );
};

export default Form;

Form.propTypes = {
  isOpenUpdate: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.any,
  setIsOpenUpdate: PropTypes.any,
  setIsOpenView: PropTypes.any,
  isOpenView: PropTypes.any,
};
